import * as Schema from "effect/Schema";
import { NonNegativeInt, TrimmedNonEmptyString } from "./baseSchemas.ts";

export const LOCAL_CONTEXT_TOOL_NAMES = [
  "list_room_members",
  "read_room_member",
  "search_all",
] as const;

/** Native provider capabilities still require the same explicit message choice. */
export const LOCAL_NATIVE_TOOL_NAMES = ["web_search"] as const;
export const LOCAL_CONTROL_TOOL_NAMES = ["cancel_conversation_summary"] as const;
export const LOCAL_TOOL_NAMES = [
  ...LOCAL_CONTEXT_TOOL_NAMES,
  ...LOCAL_NATIVE_TOOL_NAMES,
  ...LOCAL_CONTROL_TOOL_NAMES,
  "create_local_draft",
] as const;

/** A folder is a reference to its descendants, not a list of today's files.
 * A more specific explicit choice overrides its ancestors. */
export const ContextSelectionExpression = Schema.Struct({
  kind: Schema.Literals(["member", "folder"]),
  memberId: TrimmedNonEmptyString,
  selected: Schema.Boolean,
  delivery: Schema.Literals(["include", "reference"]),
});
export type ContextSelectionExpression = typeof ContextSelectionExpression.Type;

export const LocalContextSelection = Schema.Struct({
  selectionCut: NonNegativeInt,
  /** Device folder deliberately bound to this conversation; browsing grants no access. */
  codeRoot: Schema.optional(TrimmedNonEmptyString),
  sourceResolutionId: Schema.optional(TrimmedNonEmptyString),
  expressions: Schema.Array(ContextSelectionExpression),
  /** Explicit local tool choice. Absence is empty; content never seats tools. */
  tools: Schema.optional(Schema.Array(TrimmedNonEmptyString)),
});
export type LocalContextSelection = typeof LocalContextSelection.Type;

export {
  parseFilesystemMemberReference,
  type FilesystemMemberReference,
} from "./filesystemMemberReference.ts";

/** Exact device-local draft member, never a path or object digest. */
export const localDraftMemberId = (draftId: string) => `local-draft:${draftId}`;
export const parseLocalDraftMemberId = (memberId: string): string | null =>
  /^local-draft:[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/.test(memberId)
    ? memberId.slice("local-draft:".length)
    : null;
